import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertVideoUI from './insertvideoui';


export default class InsertVideo extends Plugin {
  static get pluginName() {
    return 'InsertVideo';
  }

  static get requires() {
    return [ InsertVideoUI];
  }
}
